import { render } from "./HeroiconsSolidStatusOffline.vue?vue&type=template&id=41febec0"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidStatusOffline.vue"]])

export default __exports__